module.exports = __webpack_public_path__ + "static/media/guidelines_icon.c4f14798.JPG";